import { render, staticRenderFns } from "./MarketCard.vue?vue&type=template&id=9bd7b98c&scoped=true"
import script from "./MarketCard.vue?vue&type=script&lang=js"
export * from "./MarketCard.vue?vue&type=script&lang=js"
import style0 from "./MarketCard.vue?vue&type=style&index=0&id=9bd7b98c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd7b98c",
  null
  
)

export default component.exports